import * as yup from 'yup';
import { emailField, TranslateFn } from '../../../library/validationRules';

/**
 * Without `allowAdminHandle`: the reset link has to be delivered somewhere, and a sign-in
 * handle is not a mailbox.
 */
export const createForgotPasswordSchema = (translate: TranslateFn) => yup.object({
    emailAddress: emailField(translate),
});
